import classNames from 'classnames';
import React from 'react';
import styles from './ReadOnlyField.module.scss';
import { Nullable } from '../Shared/Types';
import { Tooltip } from '@material-ui/core';

type ReadOnlyFieldProps = {
    label?: Nullable<React.ReactNode>; // Only null will hide the label completely
    hideHelperText?: boolean;
    mode?: 'heading' | 'field';
    multiLine?: boolean;
    alphanumeric?: boolean;
    noWrapping?: boolean;
    labelColour?: string;
    valueColour?: string;
    tooltipPlacement?:
        | 'bottom-end'
        | 'bottom-start'
        | 'bottom'
        | 'left-end'
        | 'left-start'
        | 'left'
        | 'right-end'
        | 'right-start'
        | 'right'
        | 'top-end'
        | 'top-start'
        | 'top';
};

export const ReadOnlyField: React.FC<ReadOnlyFieldProps> = props => {
    const nbsp = '\u00a0';
    const children = props.children === '' || React.Children.count(props.children) === 0 ? nbsp : props.children;
    const mode = props.mode ?? 'field';

    const fieldClasses = classNames(styles.readOnlyField, {
        [styles.fieldMode]: mode === 'field',
        [styles.noLabel]: props.label === null,
        [styles.noHelperText]: props.hideHelperText,
        [styles.multiLine]: props.multiLine
    });

    const valueClasses = classNames(styles.value, {
        [styles.fieldModeValue]: mode === 'field',
        [styles.alphanumeric]: props.alphanumeric,
        [styles.noWrapping]: props.noWrapping
    });

    const value = props.noWrapping ? (
        <Tooltip title={children?.toString() ?? ''} placement={props.tooltipPlacement}>
            <span>{children}</span>
        </Tooltip>
    ) : (
        children
    );

    return (
        <div className={fieldClasses}>
            {props.label !== null && (
                <div className={styles.label} style={{ color: props.labelColour }}>
                    {props.label || nbsp}
                </div>
            )}
            <div className={valueClasses} style={{ color: props.valueColour }}>
                {value}
            </div>
        </div>
    );
};
